import React from 'react';

import Lottie from 'react-lottie';
import { useAppContext } from '../../../context/AppContext';
import StepLayout from '../../../pages/_layouts/step';
import useRedirectCountdown from '../../../hooks/useRedirectCountdown';

const REDIRECT_SECONDS = 10;

const Step6 = () => {
  const { siteConfig } = useAppContext();
  const redirectUrl = siteConfig?.app_url;
  const remaining = useRedirectCountdown(REDIRECT_SECONDS, redirectUrl, {
    enabled: !!redirectUrl,
  });

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: require('../../../assets/checked.json'),

    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <StepLayout>
      <div className="step step3">
        <div className="row">
          <div className="subtitle">
            <div className="span-success">
              {' '}
              <Lottie options={defaultOptions} height={400} width={400} />
            </div>
            <span className="span-success-title">
              Pronto! Seu cadastro foi recebido com sucesso.
            </span>
            <br />
            <span className="span-success-content">
              Agora é só aguardar que iremos analisar o seu cadastro e em breve
              enviaremos as informações em seu e-mail.
            </span>
            {redirectUrl && (
              <span className="span-success-content">
                Você será redirecionado para o site em {remaining}{' '}
                {remaining === 1 ? 'segundo' : 'segundos'}.
              </span>
            )}
          </div>
          <br />
          <a href={`${siteConfig?.app_url}`}>
            <button type="button" className="button-catalog">
              Visualizar catálogo agora
            </button>
          </a>
        </div>
      </div>
    </StepLayout>
  );
};

export default Step6;
